import { matchesSearchTerm } from "@/shared/utils/tableSearch";
export const LANGUAGES = ["fr", "en", "nl"];
/** OPCAT's refusal when the user's roles do not, or no longer, manage the list. */
export const ACCESS_DENIED_ERROR_CODE = "Catalog.Access.Denied";
export const VALUE_LIST_TABS = ["all", "referentials", "contactOrganisation", "finance"];
/**
 * CONSTRAINT: the three category tabs are empty because a catalogue carries no category yet. Once
 * it does, this is the one place that maps a list to its tabs; the view only counts and renders.
 */
export function listsInTab(lists, tab) {
    return tab === "all" ? lists : [];
}
/** The catalogue language of a UI locale (fr-CA reads fr); undefined for one it carries no label in. */
export function uiLanguage(locale) {
    const language = locale.split("-")[0].toLowerCase();
    return LANGUAGES.find((candidate) => candidate === language);
}
/** The UI language's label, else English, else French; a blank label counts as missing. */
export function resolveLabel(labels, locale) {
    const own = uiLanguage(locale);
    const cascade = own ? [own, "en", "fr"] : ["en", "fr"];
    for (const language of cascade) {
        const text = labels[language]?.trim();
        if (text)
            return { text, language, isFallback: language !== cascade[0] };
    }
    return { text: "", language: undefined, isFallback: true };
}
export function valueListName(list, locale) {
    return resolveLabel(list.names, locale).text;
}
const foldAccents = (text) => text.normalize("NFD").replace(/\p{Diacritic}/gu, "");
/** True when `term` occurs in one of `parts`; accents are ignored on both sides. */
export function matchesFoldedSearch(parts, term) {
    return matchesSearchTerm(parts.map((part) => foldAccents(part ?? "")), foldAccents(term));
}
/** Every language and the code, whatever the UI language. */
export function matchesListSearch(list, term) {
    return matchesFoldedSearch([...LANGUAGES.map((language) => list.names[language]), list.code], term);
}
